export default __webpack_public_path__ + "static/media/blue_waves.ebfa53e6.svg";